import { render, staticRenderFns } from "./formAdminSector.vue?vue&type=template&id=457b9dc1"
import script from "./formAdminSector.vue?vue&type=script&lang=js"
export * from "./formAdminSector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports